<template>
  <div
    v-if="marqueeText"
    class="mx-4 mb-1 flex items-center gap-2 rounded-xl bg-white px-3 py-2 cursor-pointer active:opacity-90"
    @click="goSystemNotify"
  >
    <img :src="marqueeIcon" alt="" class="size-7 shrink-0 select-none" />
    <van-notice-bar
      :text="marqueeText"
      :scrollable="true"
      :speed="50"
      background="transparent"
      color="var(--color-text-secondary, #262626)"
      class="flex-1 min-w-0 p-0! h-5 leading-5"
    />
    <van-icon name="arrow" class="size-4 shrink-0 select-none" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useQuery } from '@tanstack/vue-query'
import { notifyBroadcastApi } from '@/api/notify'
import { stripHtml } from '@/utils'
import marqueeIcon from '@/assets/imgs/marquee.png'

const router = useRouter()

const { data } = useQuery({
  queryKey: ['notifyBroadcast'],
  queryFn: async () => {
    const res = await notifyBroadcastApi()
    return res.data
  },
  staleTime: 60_000,
})

const marqueeText = computed(() => {
  const items = data.value?.marquees ?? []
  if (!items.length) return ''
  return items
    .map((item) => stripHtml(item.content))
    .filter(Boolean)
    .join('　')
})

function goSystemNotify() {
  router.push({ name: 'NotifyCenter', query: { tab: 'system' } })
}
</script>

<style scoped>
:deep(.van-notice-bar) {
  padding: 0;
  height: 20px;
  line-height: 20px;
}
:deep(.van-notice-bar__wrap) {
  height: 20px;
}
:deep(.van-notice-bar__content) {
  font-size: 13px;
}
</style>
